export default {
  footer:
    'Mỗi ngành bao gồm tất cả cổ phiếu từ HOSE, HNX và UPCOM. (Tỷ trọng giá trị ngành được tính toán dựa trên giá trị khớp lệnh.)',

  listTimeRangeChartByKey: {
    Daily: 'Theo ngày',
    Weekly: 'Theo tuần',
    Monthly: 'Theo tháng',
  },
  chartConfig: {
    chartTitle: 'GIÁ TRỊ RÒNG THEO LOẠI NHÀ ĐẦU TƯ',
    tooltipIndividual: 'GT Cá Nhân Ròng  : {0} Tỷ',
    tooltipInstitution: 'GT Tổ Chức Trong Nước Ròng : {0} Tỷ',
    tooltipProprietary: 'GT Tự Doanh Ròng : {0} Tỷ',
    tooltipForeign: 'GT Nước Ngoài Ròng : {0} Tỷ',
    inforPrice: '{0} : {1}',
    category: 'Thời gian : {0}',
    legendIndividual: 'Cá Nhân',
    legendInstitution: 'Tổ Chức Trong Nước ',
    legendProprietary: 'Tự Doanh',
    legendForeign: 'Nước Ngoài',
    legendCode: 'Giá',
    yAxis1Title: 'Tỷ',
    yAxis2Title: 'Chỉ số giá',
  },
  dealValue: 'GT thỏa thuận',
  matchValue: 'GT khớp',
  totalValue: 'Tổng GT',
  timeRangeTable: {
    ONE_DAY: '1 NGÀY',
    FIVE_DAY: '5 NGÀY',
    TWENTY_DAY: '20 NGÀY',
    YTD: 'Từ đầu năm',
  },
  timeRangeTableExport: {
    ONE_DAY: '1 NGÀY',
    FIVE_DAY: '5 NGÀY',
    TWENTY_DAY: '20 NGÀY',
    YTD: 'YTD',
  },
  rightLabel: 'Tỷ trọng Giá trị (%)',
  listTitleTable: {
    ICB_NAME: 'NGÀNH',
    CLOSE_INDEX: 'Chỉ số',
    PERCENT_INDEX_CHANGE: '% Thay đổi',
    INDIVIDUAL: 'GT Cá Nhân Ròng',
    INSTITUTION: ' GT Tổ chức trong nước Ròng',
    PROPRIETARY: 'GT Tự doanh Ròng',
    FOREIGN: 'GT Nước ngoài Ròng',
  },

  INDIVIDUAL: 'Cá Nhân',
  INSTITUTION: 'Tổ Chức Trong Nước',
  PROPRIETARY: 'Tự Doanh',
  FOREIGN: 'Nước Ngoài',
  tooltipDate: 'Dữ liệu được tính từ ngày %{from} đến %{to}',
  tooltipToday: 'Dữ liệu được tính tại %{from}',
  tooltipInvestorToday:
    ' được cập nhật tại %{from}. Dữ liệu chỉ bao gồm sàn HOSE.',
  tooltipInvestorDate:
    ' được cập nhật từ ngày %{from} đến %{to}. Dữ liệu chỉ bao gồm sàn HOSE.',
  tooltipHose: 'Giá Trị: x 1,000,000. Dữ liệu phân loại nhà đầu tư theo ngành',
  // statInvestorNotice: {
  //   title: 'Thông báo',
  //   content:
  //     'Từ ngày 1/3/2022, dữ liệu Tự doanh được cộng dồn vào dữ liệu Tổ chức trong nước.',
  // },
};
